/* Search wildcard fix (added 2026-10-11): Turbo's autocomplete appends "*" to every
   search, making Shopify return the whole catalog. These capture-phase listeners run
   before Turbo's handlers and strip the wildcard so searches return relevant items. */
(function () {
  var SEL = '.search_form, .search__form, .header_search_form';
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(SEL)) return;
    var input = f.querySelector('input[name="q"]');
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var q = input.value.replace(/\*+$/, '').trim();
    var t = f.querySelector('input[name="type"]');
    var url = '/search?' + (t && t.value ? 'type=' + encodeURIComponent(t.value) + '&' : '') + 'q=' + encodeURIComponent(q);
    window.location.href = url;
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.search__results-wrapper a[href*="/search"]') : null;
    if (!a || a.href.indexOf('*') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href.split('*').join('');
  }, true);
})();
